/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable no-new */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
// sgf解析格式方法
import sgf from '@sabaki/sgf';
// 提子方法
import canTake from './raisin';
// 常用资对象
import { chessIconMethod, chessAudio, tzAudio } from '../common';
// 常用常量
import islandConst from '../const';
import { isArray, isNumber } from '../utils';
// createJs 对象
const cjs = window.createjs;

export default class BaseIslandBox {
  constructor(props) {
    // $el canvas对象必传递
    // 默认类型初始化
    this.options = {
      sz: 19, // 棋盘大小
      OuterRadio: 0.9, // 外框区域基于屏幕大小
      withinRadio: 0.85, // 内框区域基于屏幕大小
      showNum: true, // 数字开关
      showAudio: true, // 音频开关
      width: 500, // 绘图大小
      lastChessShow: false, // 默认显示最后一颗棋子
      ...props,
    };

    // 静态资源内容
    this.static = {
      chessAudio, // 下子音频
      tzAudio,
    };

    // Container对象内容，主要棋子，步数等放在不同的container里面，可扩展
    this.container = {
      moreChessContainer: new cjs.Container(), // 棋子container对象
      chessStepContainer: new cjs.Container(), // 下棋步数的container对象
    };

    // 如果传递sgf-content内容，默认需要解析sgf对象，以后可能会改这个逻辑
    const { content } = this.options;
    if (content) {
      this.sgfParse = sgf.parse(content)[0];
      const { SZ } = this.sgfParse.data;
      // 在有内容情况下重置棋盘大小，肯定以sgf棋盘大小为准
      this.options.sz = +SZ[0];
    }

    // 初始化静态资源(异步的过程)
    this.staticResources(() => {
      // 初始化canvas
      this.initBaseIslandBox();
      // 回调给儿子，初始化完成
      setTimeout(() => {
        this.options.complete();
      });
    });
  }

  // 初始化静态资源
  staticResources(callback) {
    const {
      width, withinRadio, OuterRadio, sz,
    } = this.options;
    // 外容器宽度
    this.static.OuterWith = width * OuterRadio;
    // 外容器距左上偏移
    this.static.OuterOffset = width * (1 - OuterRadio) / 2;
    // 内容器宽度
    this.static.withinWith = width * withinRadio;
    // 内容器距左上偏移
    this.static.withinOffset = width * (1 - withinRadio) / 2;
    // 棋子宽度
    this.static.chessWidth = this.static.withinWith / (sz - 1);
    // 棋子半径
    this.static.chessR = this.static.chessWidth / 2 * 0.95;
    // 字体大小
    this.static.fontSize = this.static.chessR * 1.4;
    // 图片棋子缩放比
    this.static.pngScale = this.static.chessWidth / islandConst.chessWidth;
    // 棋子图片资源(异步过程)
    new chessIconMethod({
      onSuccess: (chessSpt) => {
        this.static.chessSpt = chessSpt;
        callback();
      },
    });
  }

  // 初始化canvas
  initBaseIslandBox() {
    const { $el } = this.options;
    // 画布对象
    this.stage = new cjs.Stage($el);
    // 背景初始化
    this.bgInit();
    // 画线
    this.drawLine();
    // 初始化棋子container和棋子步数container偏移
    this.initChessContainer();
    // 初始化常用的对象
    this.initObj();
    // 画棋子
    this.drawChess();
    // 移动端开启事件
    cjs.Touch.enable(this.stage);
    // 更新画布
    this.stage.update();
  }

  // 背景初始化
  bgInit() {
    const { stage, options } = this;
    const { width } = options;
    // 构建一个对象正方形
    const react = new cjs.Shape();
    react.graphics.beginFill(islandConst.borderColor)
      .drawRect(0, 0, width, width);
    // add
    stage.addChild(react);
  }

  // 画线
  drawLine() {
    const { stage, options } = this;
    const { sz } = options;
    const {
      OuterWith, OuterOffset, withinWith, withinOffset, chessWidth,
    } = this.static;
    const shape = new cjs.Shape();
    const { graphics } = shape;
    // 外框
    graphics.setStrokeStyle(2)
      .beginStroke('#000');
    graphics.drawRect(OuterOffset, OuterOffset, OuterWith, OuterWith);

    graphics.setStrokeStyle(1)
      .beginStroke('#000');
    for (let i = 0; i < sz; i++) {
      const y = withinOffset + chessWidth * i;
      graphics.moveTo(withinOffset, y)
        .lineTo(withinOffset + withinWith, y);
      graphics.moveTo(y, withinOffset)
        .lineTo(y, withinOffset + withinWith);
    }

    // 画点
    graphics.endStroke();
    const r = 6;
    if (+sz === 9) {
      for (let i = 1; i <= 2; i++) {
        for (let j = 1; j <= 2; j++) {
          const x = withinOffset + chessWidth * (i * 4 - 2);
          const y = withinOffset + chessWidth * (j * 4 - 2);
          graphics.beginFill('#333');
          graphics.drawCircle(x, y, r);
          graphics.endFill();
        }
      }
    }

    stage.addChild(shape);
  }

  // 初始化棋子container和棋子步数container偏移
  initChessContainer() {
    const { withinOffset } = this.static;
    const { moreChessContainer, chessStepContainer } = this.container;
    moreChessContainer.x = withinOffset;
    moreChessContainer.y = withinOffset;
    chessStepContainer.x = withinOffset;
    chessStepContainer.y = withinOffset;
    chessStepContainer.visible = this.options.showNum;
    // 添加棋子对象
    this.stage.addChild(moreChessContainer);
    // 添加棋子步数对象
    this.stage.addChild(chessStepContainer);
  }

  // 初始化常用对象
  initObj() {
    const { sz, lastChessShow } = this.options;
    // 落子最后一颗棋子是否需要显示一个三角符号
    this.LastChess = {
      show: lastChessShow,
      chess: [], // 显示三角符号对象有哪些
    };
    // 透明棋子对象
    this.alphaChess = [];
    // 坐标系棋子存储对象
    this.coordinateChess = {};
    // 常规棋子对象
    this.chess = [];
    // 棋子数字对象，用于提子使用
    this.chessArray = [];
    // 步数对象
    this.chessStepText = [];
    for (let i = 0; i < sz; i++) {
      this.chess[i] = [];
      this.chessArray[i] = [];
      this.chessStepText[i] = [];
      for (let j = 0; j < sz; j++) {
        this.chess[i][j] = false;
        this.chessArray[i][j] = -1;
        this.chessStepText[i][j] = false;
      }
    }
  }

  // 画棋子
  // type 无，不提前画任何棋子
  // type 0,4 全量画透明棋子,有绑定事件。
  // type 1, 2 cotent必传，只画传过来棋子，无绑定事件。
  // type 3 cotent必传，只画传过来棋子，有绑定事件。
  drawChess() {
    const { type } = this.options;

    if (type === 0 || type === 4) {
      // 画所有透明棋子（并且绑定事件）
      this.drawAllChess();
    } else if (type === 1 || type === 2) {
      // 判断题和选择题，没有事件绑定
      this.initSgfContent();
    } else if (type === 3) {
      // 特殊题型，需要在棋子上做事件绑定
      this.initSgfContent(true); // true 绑定事件
    }
  }

  // 把content内容画上棋盘
  initSgfContent(isbindEvent) {
    const { sgfParse } = this;
    if (sgfParse) {
      const {
        AP, AB, AW, TR, LB,
      } = sgfParse.data;
      // 黑棋
      if (AB && isArray(AB)) {
        this.initChess(AB, islandConst.BLACK, isbindEvent);
      }
      // 白棋
      if (AW && isArray(AW)) {
        this.initChess(AW, islandConst.WHITE, isbindEvent);
      }
      // 带三角形的棋子(考虑三角形都在棋子上)
      if (TR && isArray(TR)) {
        TR.forEach((item) => {
          let chess;
          if (AP[0] === 'M1.0') {
            chess = this.coordinateChess[item];
          } else {
            const num = this.letterTurnAllNum(item);
            chess = this.chess[num[0]][num[1]];
          }
          if (chess) {
            if (chess.chessType === islandConst.BLACK) {
              chess.gotoAndStop('c13');
            } else if (chess.chessType === islandConst.WHITE) {
              chess.gotoAndStop('c11');
            }
          }
        });
      }

      // 带数字的棋子(默认一定存在棋子)
      if (LB && isArray(LB)) {
        LB.forEach((item) => {
          const data = item.split(':');
          const p = data[0];
          const step = data[1];
          let chess; let
            num;
          if (AP[0] === 'M1.0') {
            chess = this.coordinateChess[p];
          } else {
            num = this.letterTurnAllNum(p);
            chess = this.chess[num[0]][num[1]];
          }
          if (chess) {
            chess.chessStep = step;
            this.drawStep(chess);
          } else {
            const { fontSize, chessWidth, withinOffset } = this.static;
            const text = new cjs.Text(step, `${fontSize + 4}px Arial`, '#fff');
            text.textAlign = 'center';
            text.textBaseline = 'middle';
            text.x = num[0] * chessWidth + withinOffset;
            text.y = num[1] * chessWidth + withinOffset;
            this.stage.addChild(text);
          }
        });
      }
    }
  }

  // 初始化填充棋子
  initChess(chesss, type, isbindEvent) {
    const { data } = this.sgfParse;
    const { chessSpt } = this.static;
    if (data.AP[0] === 'M1.0') {
      // 坐标系绘制点位
      chesss.forEach((coordinate) => {
        const point = this.coordinateTurnAllPoint(coordinate);
        let sprite = this.coordinateChess[coordinate];
        if (!sprite) {
          sprite = new cjs.Sprite(chessSpt);
          this.container.moreChessContainer.addChild(sprite);
        }
        sprite.coordinate = {
          x: point[0],
          y: point[1],
          coordinate,
        };
        if (type === islandConst.BLACK) {
          this.drawBackChess(sprite, point[0], point[1]);
        } else if (type === islandConst.WHITE) {
          this.drawWhiteChess(sprite, point[0], point[1]);
        } else if (type === islandConst.TRIANGLE) {
          this.drawTriangleChess(sprite, point[0], point[1]);
        }
        if (isbindEvent) {
          this.bindBaseEvents(sprite);
        }
      });
    } else {
      // 标准点位
      chesss.forEach((letter) => {
        const num = this.letterTurnAllNum(letter);
        let sprite = this.chess[num[0]][num[1]];
        if (!sprite) {
          sprite = new cjs.Sprite(chessSpt);
          this.container.moreChessContainer.addChild(sprite);
        }
        sprite.point = {
          x: num[0],
          y: num[1],
          letter,
        };
        const point = this.calculationPoint(sprite, num[0], num[1]);
        if (type === islandConst.BLACK) {
          this.drawBackChess(sprite, point.x, point.y);
        } else if (type === islandConst.WHITE) {
          this.drawWhiteChess(sprite, point.x, point.y);
        } else if (type === islandConst.TRIANGLE) {
          this.drawTriangleChess(sprite, point.x, point.y);
        }
        if (isbindEvent) {
          this.bindBaseEvents(sprite);
        }
      });
    }
  }

  // 点位计算
  calculationPoint(sprite, x, y) {
    const { chessWidth } = this.static;
    if (sprite.x) {
      return {
        x: sprite.x,
        y: sprite.y,
      };
    }
    return {
      x: chessWidth * x,
      y: chessWidth * y,
    };
  }

  // 全量画棋子(透明)
  drawAllChess() {
    const { sz } = this.options;
    const { chessWidth, chessSpt } = this.static;
    for (let i = 0; i < sz; i++) {
      for (let j = 0; j < sz; j++) {
        const sprite = new cjs.Sprite(chessSpt);
        const rx = i * chessWidth;
        const ry = j * chessWidth;
        sprite.point = {
          x: i,
          y: j,
          letter: this.numTurnAllLetter([i, j]),
        };
        // 绘制空白点
        this.drawTransparentChess(sprite, rx, ry);
        this.bindBaseEvents(sprite);
        // 添加对象
        this.container.moreChessContainer.addChild(sprite);
      }
    }
  }

  // 清除透明棋子保存的数据
  clearAlphaChessData() {
    this.alphaChess = [];
  }

  // 设置一些状态
  setStatus(sprite, type) {
    if (sprite.point) {
      const { x, y } = sprite.point;
      // 棋子对象
      this.chess[x][y] = sprite;
      // 代表规则题型
      this.chessArray[x][y] = type;

      // 如果要显示最后一颗棋子为三角形
      if (this.LastChess.show && (type === islandConst.BLACK || type === islandConst.WHITE)) {
        this.LastChess.chess.forEach((chess) => {
          if (chess.chessType === islandConst.BLACK) {
            chess.gotoAndStop('c6');
          } else if (chess.chessType === islandConst.WHITE) {
            chess.gotoAndStop('c1');
          }
        });
        this.LastChess.chess = [sprite];
        if (type === islandConst.BLACK) {
          sprite.gotoAndStop('c13');
        } else if (type === islandConst.WHITE) {
          sprite.gotoAndStop('c11');
        }
      }
    } else if (sprite.coordinate) {
      const { coordinate } = sprite.coordinate;
      this.coordinateChess[coordinate] = sprite;
    }

    // 棋子步数
    if (isNumber(sprite.chessStep)) {
      this.drawStep(sprite);
    }
  }

  // 步数
  drawStep(sprite) {
    const { chessStep, chessType } = sprite;
    const { fontSize } = this.static;
    if (chessType === islandConst.WHITE || chessType === islandConst.BLACK) {
      const text = new cjs.Text(chessStep, `${fontSize}px Arial`, this.getColor(chessType));
      text.textAlign = 'center';
      text.textBaseline = 'middle';
      text.x = sprite.x;
      text.y = sprite.y;
      if (this.sgfParse && this.sgfParse.data && this.sgfParse.data.AP && this.sgfParse.data.AP[0] === 'M1.0') {
        // 不规则棋子（先不做保存处理，现在没有这个场景）
        this.container.chessStepContainer.addChild(text);
      } else {
        this.chessStepText[sprite.point.x][sprite.point.y] = text;
        this.container.chessStepContainer.addChildAt(text, chessStep - 1);
      }
    } else {
      const textObj = this.chessStepText[sprite.point.x][sprite.point.y];
      if (textObj) {
        textObj.visible = false;
        textObj.text = '';
      }
    }
  }

  // 透明棋子
  drawTransparentChess(sprite, rx, ry) {
    const { pngScale } = this.static;
    sprite.x = rx;
    sprite.y = ry;
    sprite.regX = islandConst.chessWidth / 2;
    sprite.regY = islandConst.chessWidth / 2;
    sprite.alpha = 0.01;
    sprite.scaleX = pngScale;
    sprite.scaleY = pngScale;
    sprite.chessType = islandConst.EMPTY;
    this.setStatus(sprite, islandConst.EMPTY);
  }

  // 黑棋
  drawBackChess(sprite, rx, ry, alpha = 1) {
    const { pngScale } = this.static;
    this.changeAlpha(sprite, alpha);
    sprite.x = rx;
    sprite.y = ry;
    sprite.regX = islandConst.chessWidth / 2;
    sprite.regY = islandConst.chessWidth / 2;
    sprite.alpha = alpha || 1;
    sprite.scaleX = pngScale;
    sprite.scaleY = pngScale;
    sprite.chessType = islandConst.BLACK;
    sprite.gotoAndStop('c6');
    this.setStatus(sprite, islandConst.BLACK);
  }

  // 白棋
  drawWhiteChess(sprite, rx, ry, alpha = 1) {
    const { pngScale } = this.static;
    this.changeAlpha(sprite, alpha);
    sprite.x = rx;
    sprite.y = ry;
    sprite.regX = islandConst.chessWidth / 2;
    sprite.regY = islandConst.chessWidth / 2;
    sprite.alpha = alpha || 1;
    sprite.scaleX = pngScale;
    sprite.scaleY = pngScale;
    sprite.chessType = islandConst.WHITE;
    sprite.gotoAndStop('c1');
    this.setStatus(sprite, islandConst.WHITE);
  }

  // 透明度计算
  changeAlpha(sprite, alpha) {
    this.alphaChess.forEach((chess) => {
      this.drawTransparentChess(chess, chess.x, chess.y);
    });
    this.clearAlphaChessData();
    if (alpha && alpha !== 1) {
      this.alphaChess = [sprite];
    }
  }

  // 三角形棋子
  drawTriangleChess(sprite, rx, ry) {
    const { pngScale } = this.static;
    sprite.x = rx;
    sprite.y = ry;
    sprite.regX = islandConst.chessWidth / 2;
    sprite.regY = islandConst.chessWidth / 2;
    sprite.alpha = 1;
    sprite.scaleX = pngScale;
    sprite.scaleY = pngScale;
    sprite.gotoAndStop('c13');
  }

  // 单个棋子绑定事件
  bindBaseEvents(sprite) {
    const { chessClick } = this.options;
    sprite.addEventListener('click', (e) => {
      chessClick && chessClick(sprite);
    });
  }

  // 字母转数字
  letterTurnAllNum(letter) {
    const { sz } = this.options;
    letter = letter.toLocaleUpperCase();
    if (/^[a-zA-Z]*$/.test(letter)) {
      //  return [(letter.charCodeAt(0) - 65), (sz - (letter.charCodeAt(1) - 64))]; //左下
      return [(letter.charCodeAt(0) - 65), (letter.charCodeAt(1) - 65)]; // 左上
    }
    return letter;
  }

  // 数字全部转数组
  numTurnAllLetter(numArray) {
    const sz = +this.options.sz;
    // return String.fromCharCode(numArray[0] + 65) + String.fromCharCode(64 + sz - numArray[1]);  //左下
    return String.fromCharCode(numArray[0] + 65) + String.fromCharCode(numArray[1] + 65); // 左上
  }

  // 坐标转换
  coordinateTurnAllPoint(coordinate) {
    const { chessWidth } = this.static;
    const rx = +coordinate.slice(0, 2) * chessWidth / 10;
    const ry = +coordinate.slice(2) * chessWidth / 10;
    return [rx, ry];
  }

  // 提子
  tiZiMethod(numArray, type) {
    const tiZiType = type == 'B' ? islandConst.BLACK : islandConst.WHITE;
    const ClearChess = canTake(this.chessArray, tiZiType, numArray[0], numArray[1], this.options.sz);
    if (ClearChess.length > 0) {
      ClearChess.forEach((v) => {
        // 绘制空白棋子
        const sprite = this.chess[v[0]][v[1]];
        this.drawTransparentChess(sprite, sprite.x, sprite.y);
      });
    }
  }

  // 获得颜色
  getColor(chessType) {
    if (chessType === islandConst.WHITE) {
      return '#000';
    }
    if (chessType === islandConst.BLACK) {
      return '#fff';
    }
  }

  // 清除下过棋子和步数重置
  off() {
    this.stage.removeAllChildren();
  }
}
